<div class="footer-container">
  <ul class="list-inline mx-4 mb-0">
    <li class="list-inline-item text-main">
      &copy; {{ year }} Tila Top up INC.
    </li>
    <li class="list-inline-item float-end me-4">
      <a routerLink="/features/about-us" class="text-decoration-none" translate
        >pages.placeholders.aboutus</a
      >
    </li>
    <li class="list-inline-item float-end me-4">
      <a routerLink="/features/contact-us" class="text-decoration-none" translate
        >pages.sidebar.contactUs</a
      >
    </li>
    <li class="list-inline-item float-end me-4">
      <a routerLink="/features/terms-conditions" class="text-decoration-none" translate
        >pages.sidebar.termsConditions</a
      >
    </li>
    <li class="list-inline-item float-md-end me-md-4">
      v {{environment.version}}
    </li>
  </ul>
</div>
